module.exports = __webpack_public_path__ + "img/image.6c76c6cc.svg";